module.exports = __webpack_public_path__ + "static/media/info.ae68731a.svg";